<div class="sidenav" fxLayout="column" (keydown.escape)="$event.stopPropagation()">
  <div class="sidenav-toolbar" fxLayout="row" fxLayoutAlign="start center">
    <div [routerLink]="['/']" class="sidenav-toolbar-logo">
      <div class="logo fill-primary-contrast">
        <img src="./assets/img/logo-dark.png" />
      </div>
    </div>

    <span fxFlex><!-- fill space --></span>

    <!--<div fxFlexAlign="center" fxHide fxShow.gt-md>
      <button (click)="toggleCollapsed()" class="sidenav-toolbar-collapse-toggle" mat-icon-button>
        <mat-icon *ngIf="!collapsed" class="sidenav-toolbar-collapse-icon">radio_button_checked</mat-icon>
        <mat-icon *ngIf="collapsed" class="sidenav-toolbar-collapse-icon">radio_button_unchecked</mat-icon>
      </button>
    </div>-->
    <!-- <button (click)="openQuickPanel.emit()">CHAT</button> -->
  </div>

  <fury-scrollbar class="sidenav-items" fxFlex="auto">
    <div *ngIf="sidenavUserVisible$ | async" class="sidenav-user">
      <app-avatar-display [size]="'big'" [picture]="profile.picture"></app-avatar-display>

      <h3 class="sidenav-user-name" *ngIf="profile">{{ profile.name | htmlScape }}</h3>
      <h4 class="sidenav-user-email" *ngIf="profile">{{ profile.email }}</h4>

      <div>
        <p class="sidenav-user-superAdmin" *ngIf="managedService">Responsable : {{ managedService.name }}</p>

        <p class="sidenav-user-superAdmin" *ngIf="profile && profile.isSuperAdmin">Administrateur</p>
        <p class="sidenav-user-superAdmin" *ngIf="profile && !profile.isSuperAdmin">Collaborateur</p>

        <ul style="list-style: none; padding: 0">
          <ng-container *ngFor="let service of userServices | async">
            <li>{{ service.name }}</li>
          </ng-container>
        </ul>
      </div>

      <div class="sidenav-user-icons" fxLayout="row">
        <a mat-icon-button [routerLink]="['/']" matTooltip="Retour sur la page principal">
          <mat-icon>home</mat-icon>
        </a>
        <a mat-icon-button (click)="disconnect()" matTooltip="Déconnectez-vous">
          <mat-icon>exit_to_app</mat-icon>
        </a>
      </div>
    </div>

    <fury-sidenav-item *ngFor="let item of items$ | async" [item]="item" [level]="0"></fury-sidenav-item>
  </fury-scrollbar>
</div>
